
const cfgMagazines = [
  "M16", 
  "M4", 
  "AK47", 
  "AK47CZ", 
  "AK74", 
  "AK74SU", 
  "HK", 

  "HKG3Mag",
  "G36aMag",
  "SteyrMag",

  "M21", 
  "SVDDragunov", 
  "HuntingRifleMag",
  "KozliceShell",
  "KozliceBall",
  "M60", 
  "PK", 

  "BerettaMag",
  "CZ75Mag",
  "GlockMag",
  "GlockSMag",
  "IngramMag",
  "RevolverMag",
  "SkorpionMag",
  "TokarevMag",
  "UZIMag",

  "MM1Magazine",
  "6G30Magazine",

  "GrenadeLauncher", 
  "Mortar", 
  "Flare", 
  "FlareGreen", 
  "FlareRed", 
  "FlareYellow", 
  "HandGrenade", 
  "SmokeShell", 
  "SmokeShellRed", 
  "SmokeShellGreen", 
  "TimeBomb", 
  "Mine", 
  "MineE", 
  "PipeBomb", 
  "LAWLauncher", 
  "RPGLauncher", 
  "CarlGustavLauncher", 
  "AT4Launcher", 
  "AALauncher", 
  "9K32Launcher", 
  "AT3Launcher",

  "LaserDesignator"
];

export default cfgMagazines;